<template>
  <div class="model-detail">
    <header class="detail-header">
      <div class="detail-header-container">
        <button class="back-button" v-if="!hideBackBtn" @click="goBack">
          ← 返回列表
        </button>
        <h1>{{ getModelDisplayName(modelName || modelUrl) }}</h1>
        <div v-if="urlList.length">
          <button
            v-for="(item, index) in urlList"
            :key="index"
            class="model-item"
            :class="{ 'current': item.show }"
            @click="item.show ?  unloadModel(index):loadModel(index)">
            {{ index + 1  }}
          </button>
        </div>
      </div>
      <button class="info-panel-btn" :class="{'current': showInfoPanelStatus}" @click="showInfoPanel()">信息面板</button>
    </header>
    <div class="model-viewer" ref="sceneContainer" id="js-simple-viewer">
      <div id="scene"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import SimpleViewer from '../infranstructure/viewers/simple-viewer'
import { ModelList } from '../configs'


const router = useRouter()
const route = useRoute()
const sceneContainer = ref(null)
const modelName = ref('模型')
const modelUrl = ref('')
// const hideBackBtn = ref(route.query.hideBackBtn === 'true')
const hideBackBtn = ref(false);
const showInfoPanelStatus = ref(false);
const urlList = ref([]);

let viewer = null


const getModelDisplayName = (model) => {
  if(model.indexOf("http") >= 0) return '模型'
  return ModelList[model]?.name || model
}

const goBack = () => {
  router.push('/')
}

const loadModel = async (index)=>{
  await viewer.add(index);
  urlList.value = viewer.getUrls().map(item=> {return {url: item.url, show: item.show}});
}

const unloadModel = async (index)=>{
  await viewer.remove(index);
  urlList.value = viewer.getUrls().map(item=> {return {url: item.url, show: item.show}});
}

const showInfoPanel = () => {
  viewer.showInfoPanel(!showInfoPanelStatus.value);
  showInfoPanelStatus.value = !showInfoPanelStatus.value;
}

onMounted(async () => {
  // 初始化3D查看器
  try {
    await init();
    let configUrl = '';
    debugger
    if(modelUrl.value && modelUrl.value !== ''){
      configUrl = decodeURIComponent(modelUrl.value);
    }else if(modelName.value && modelName.value !== ''){
      configUrl = `/models/${modelName.value}/model.meta.json`;
    }
    viewer = new SimpleViewer('#scene');
    await viewer.init(configUrl);
    urlList.value = viewer.getUrls();
    console.log('urlList', viewer.getUrls(), urlList.value)

    showInfoPanel();

  } catch (error) {
    console.error('Failed to initialize 3D viewer:', error)
  }
})

onUnmounted(() => {
  // 清理资源
  if (viewer && viewer.dispose) {
    viewer.dispose()
  }
});


const init = ()=> {
  // 获取 hash 部分（去除 #）
  const hashString = window.location.href.split('#/simple-viewer')[1];   // 或 window.location.hash.slice(1) 在实际页面上
  // 用 URLSearchParams 解析
  const params = new URLSearchParams(hashString);

  const sceneUrl = params.get('sceneUrl');
  modelUrl.value = sceneUrl;
}
</script>

<style scoped>
.model-detail {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #000;
}

.detail-header {
  background: rgba(0, 0, 0, 0.8);
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  z-index: 10;
}
.detail-header-container{
  flex: 1;
  align-items: center;
  flex-direction:row;
  display: flex;gap: 1rem;
}
.info-panel-btn{
  font-size: 0.6rem;
}
.info-panel-btn.current{
  background-color: white;
  color: #000;
}
.back-button {
  padding: 0.5rem 1rem;
  background: rgba(108, 117, 125, 0.9);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.back-button:hover {
  background: rgba(90, 98, 104, 0.9);
}

.detail-header h1 {
  margin: 0;
  color: white;
  font-weight: 500;
    font-size: 1.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.model-viewer {
  flex: 1;
  position: relative;
  background: #000;
}

#scene {
  width: 100%;
  height: 100%;
}
.model-item{
  margin-right: 0.2rem;
  font-size: 0.7rem;
  background: #000;
  color: white;
  border: 1px solid white;
}
.model-item.current {
  background: white;
  color: #000;
}
</style>
